import { computed } from '@vue/composition-api'
import useHttpGet from 'states/generics/useHttpGet'

export default function useFeaturedStartupsFetch({ orgId }) {
  const url = `/organizations/${orgId}/featured-startups`
  const {
    response: featuredStartupsResponse,
    getInProgress: fetchFeaturedStartupsInProgress,
    get: fetchFeaturedStartups,
  } = useHttpGet({ url, sleep: 500 })

  const featuredStartupsGroups = computed(() => {
    return featuredStartupsResponse.value
      ? featuredStartupsResponse.value.data.groups || []
      : []
  })

  return {
    featuredStartupsGroups,
    featuredStartupsResponse,
    fetchFeaturedStartups,
    fetchFeaturedStartupsInProgress,
  }
}
